(function () {

/*!
 * mmenu.js
 * mmenujs.com
 *
 * Copyright (c) Fred Heusschen
 * frebsite.nl
 */ //	Core
const $00e8806cc73bef1a$var$options = {
    hooks: {},
    navbar: {
        add: true,
        title: 'Menu',
        titleLink: 'parent'
    },
    slidingSubmenus: true
};
var $00e8806cc73bef1a$export$2e2bcd8739ae039 = $00e8806cc73bef1a$var$options;


const $95ac14b6bfd84d23$var$configs = {
    classNames: {
        divider: 'Divider',
        nolistview: 'NoListview',
        nopanel: 'NoPanel',
        panel: 'Panel',
        selected: 'Selected',
        vertical: 'Vertical'
    },
    language: null,
    panelNodetype: [
        'ul',
        'ol',
        'div'
    ],
    screenReader: {
        closeSubmenu: 'Close submenu',
        openSubmenu: 'Open submenu',
        toggleSubmenu: 'Toggle submenu'
    }
};
var $95ac14b6bfd84d23$export$2e2bcd8739ae039 = $95ac14b6bfd84d23$var$configs;


/**
 * Deep extend an object with the given defaults.
 * Note that the extended object is not a clone, meaning the original object will also be updated.
 *
 * @param 	{object}	orignl	The object to extend to.
 * @param 	{object}	dfault	The object to extend from.
 * @return	{object}			The extended "orignl" object.
 */ const $9873b750a4e3050d$export$8b58be045bf06082 = (orignl, dfault)=>{
    if ($9873b750a4e3050d$export$bf9fb029d174d554(orignl) != 'object') orignl = {};
    if ($9873b750a4e3050d$export$bf9fb029d174d554(dfault) != 'object') dfault = {};
    for(let k in dfault){
        if (!dfault.hasOwnProperty(k)) continue;
        if (typeof orignl[k] == 'undefined') orignl[k] = dfault[k];
        else if ($9873b750a4e3050d$export$bf9fb029d174d554(orignl[k]) == 'object') $9873b750a4e3050d$export$8b58be045bf06082(orignl[k], dfault[k]);
    }
    return orignl;
};
const $9873b750a4e3050d$export$c69521134f103c95 = (surface)=>{
    let direction = '';
    let prevPosition = null;
    surface.addEventListener('touchstart', (evnt)=>{
        if (evnt.touches.length === 1) {
            direction = '';
            prevPosition = evnt.touches[0].pageY;
        }
    });
    surface.addEventListener('touchend', (evnt)=>{
        if (evnt.touches.length === 0) {
            direction = '';
            prevPosition = null;
        }
    });
    surface.addEventListener('touchmove', (evnt)=>{
        direction = '';
        if (prevPosition && evnt.touches.length === 1) {
            const currentPosition = evnt.changedTouches[0].pageY;
            if (currentPosition > prevPosition) direction = 'down';
            else if (currentPosition < prevPosition) direction = 'up';
            prevPosition = currentPosition;
        }
    });
    return {
        get: ()=>direction
    };
};
const $9873b750a4e3050d$export$bf9fb029d174d554 = (variable)=>{
    return ({}).toString.call(variable).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
const $9873b750a4e3050d$export$8b15d37bc3f197d4 = ()=>{
    return `mm-${$9873b750a4e3050d$var$__id++}`;
};
let $9873b750a4e3050d$var$__id = 0;
const $9873b750a4e3050d$export$e901557d2458811 = (id)=>{
    if (id.slice(0, 9) == 'mm-clone-') return id;
    return `mm-clone-${id}`;
};
const $9873b750a4e3050d$export$77c7ff3a98df843b = (id)=>{
    if (id.slice(0, 9) == 'mm-clone-') return id.slice(9);
    return id;
};


const $17526d088c38b2ee$var$translations = {};
const $17526d088c38b2ee$export$57bf213be019eeb0 = ()=>{
    return $17526d088c38b2ee$var$translations;
};
const $17526d088c38b2ee$export$e16d8520af44a096 = (text, language)=>{
    if (typeof $17526d088c38b2ee$var$translations[language] === 'undefined') $17526d088c38b2ee$var$translations[language] = {};
    (0, $9873b750a4e3050d$export$8b58be045bf06082)($17526d088c38b2ee$var$translations[language], text);
};
const $17526d088c38b2ee$export$3988ae62b71be9a3 = (text, language)=>{
    if (typeof language === 'string' && typeof $17526d088c38b2ee$var$translations[language] !== 'undefined') return $17526d088c38b2ee$var$translations[language][text] || text;
    return text;
};


var $da63b70dabca98c5$export$2e2bcd8739ae039 = {
    'Close submenu': "Untermen\xfc schlie\xdfen",
    'Menu': "Men\xfc",
    'Open submenu': "Untermen\xfc \xf6ffnen",
    'Toggle submenu': "Untermen\xfc wechseln"
};


var $3010fac5997c76cb$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0628\u0633\u062A\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    'Menu': "\u0645\u0646\u0648",
    'Open submenu': "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    'Toggle submenu': "\u0633\u0648\u06CC\u06CC\u0686 \u0632\u06CC\u0631\u0645\u0646\u0648"
};


var $f69358d9d22bace1$export$2e2bcd8739ae039 = {
    'Close submenu': 'Submenu sluiten',
    'Menu': 'Menu',
    'Open submenu': 'Submenu openen',
    'Toggle submenu': 'Submenu wisselen'
};


var $01486d8861e09ca6$export$2e2bcd8739ae039 = {
    'Close submenu': 'Fechar submenu',
    'Menu': 'Menu',
    'Open submenu': 'Abrir submenu',
    'Toggle submenu': 'Alternar submenu'
};


var $9218699d01541f83$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    'Menu': "\u041C\u0435\u043D\u044E",
    'Open submenu': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    'Toggle submenu': "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E"
};


var $34e217f925d2e307$export$2e2bcd8739ae039 = {
    'Close submenu': "Zatvori\u0165 submenu",
    'Menu': 'Menu',
    'Open submenu': "Otvori\u0165 submenu",
    'Toggle submenu': "Prepn\xfa\u0165 submenu"
};


var $e041302473f90834$export$2e2bcd8739ae039 = {
    'Close submenu': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E",
    'Menu': "\u041C\u0435\u043D\u044E",
    'Open submenu': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E",
    'Toggle submenu': "\u041F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u043F\u0456\u0434\u043C\u0435\u043D\u044E"
};


function $a5b9348af8ea14c1$export$2e2bcd8739ae039() {
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $da63b70dabca98c5$export$2e2bcd8739ae039), 'de');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $3010fac5997c76cb$export$2e2bcd8739ae039), 'fa');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $f69358d9d22bace1$export$2e2bcd8739ae039), 'nl');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $01486d8861e09ca6$export$2e2bcd8739ae039), 'pt_br');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $9218699d01541f83$export$2e2bcd8739ae039), 'ru');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $34e217f925d2e307$export$2e2bcd8739ae039), 'sk');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $e041302473f90834$export$2e2bcd8739ae039), 'uk');
}


/**
 * Create an element with classname.
 *
 * @param 	{string}		selector	The nodeName and classnames for the element to create.
 * @return	{HTMLElement}				The created element.
 */ const $c9efe65a4853959a$export$185802fd694ee1f5 = (selector)=>{
    const args = selector.split('.'), elem = document.createElement(args.shift());
    elem.classList.add(...args);
    return elem;
};
const $c9efe65a4853959a$export$71aa6c912b956294 = (element, filter)=>{
    return filter.length ? [].slice.call(element.querySelectorAll(filter)) : [];
};
const $c9efe65a4853959a$export$bacb5cc5a11aef16 = (element, filter)=>{
    const children = Array.prototype.slice.call(element.children);
    return filter ? children.filter((child)=>child.matches(filter)) : children;
};
const $c9efe65a4853959a$export$b3ad2b0b0d33f91a = (element)=>{
    return element ? [].slice.call(element.childNodes).filter((node)=>node.nodeType === Node.TEXT_NODE).map((node)=>node.nodeValue.trim()).join(' ') : '';
};
const $c9efe65a4853959a$export$6f093cfa640b7166 = (element)=>{
    return [].slice.call(element.childNodes).filter((child)=>!child.ariaHidden).map((child)=>child.textContent).join(' ');
};
const $c9efe65a4853959a$export$7901f6cd558b9a93 = (element, filter)=>{
    /** Array of preceding elements that match the selector. */ let parents = [];
    /** Array of preceding elements that match the selector. */ let parent = element.parentElement;
    while(parent){
        parents.push(parent);
        parent = parent.parentElement;
    }
    return filter ? parents.filter((parent)=>parent.matches(filter)) : parents;
};
const $c9efe65a4853959a$export$5a01ccd45552d0b4 = (element, filter)=>{
    /** Array of previous siblings that match the selector. */ let previous = [];
    /** Current element in the loop */ let current = element.previousElementSibling;
    while(current){
        if (!filter || current.matches(filter)) previous.push(current);
        current = current.previousElementSibling;
    }
    return previous;
};
const $c9efe65a4853959a$export$cc800923e997bb8 = (element, direction)=>{
    return element.getBoundingClientRect()[direction] + document.body[direction === 'left' ? 'scrollLeft' : 'scrollTop'];
};
const $c9efe65a4853959a$export$72ac92c27fa3be94 = (listitems)=>{
    return listitems.filter((listitem)=>!listitem.matches('.mm-hidden'));
};
const $c9efe65a4853959a$export$f6486d4f577dfcc4 = (listitems)=>{
    let anchors = [];
    $c9efe65a4853959a$export$72ac92c27fa3be94(listitems).forEach((listitem)=>{
        anchors.push(...$c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, 'a.mm-listitem__text'));
    });
    return anchors.filter((anchor)=>!anchor.matches('.mm-btn--next'));
};
const $c9efe65a4853959a$export$9604f4b73fb157f3 = (element, oldClass, newClass)=>{
    if (element.matches('.' + oldClass)) element.classList.add(newClass);
};



/** Collection of callback functions for media querys. */ let $539d76ccec06870f$var$listeners = {};
const $539d76ccec06870f$export$e16d8520af44a096 = (query, yes, no)=>{
    if (typeof query == 'number') query = '(min-width: ' + query + 'px)';
    $539d76ccec06870f$var$listeners[query] = $539d76ccec06870f$var$listeners[query] || [];
    $539d76ccec06870f$var$listeners[query].push({
        yes: yes,
        no: no
    });
};
const $539d76ccec06870f$export$3db5d71bdb2d5499 = ()=>{
    for(let query in $539d76ccec06870f$var$listeners){
        let mqlist = window.matchMedia(query);
        $539d76ccec06870f$export$46ff36df9b99bc25(query, mqlist);
        mqlist.onchange = (evnt)=>{
            $539d76ccec06870f$export$46ff36df9b99bc25(query, mqlist);
        };
    }
};
const $539d76ccec06870f$export$46ff36df9b99bc25 = (query, mqlist)=>{
    var fn = mqlist.matches ? 'yes' : 'no';
    for(let m = 0; m < $539d76ccec06870f$var$listeners[query].length; m++)$539d76ccec06870f$var$listeners[query][m][fn]();
};



var $52a95b04b2a63e73$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
};
var $52a95b04b2a63e73$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $52a95b04b2a63e73$var$_panelObserver, $52a95b04b2a63e73$var$_listviewObserver, $52a95b04b2a63e73$var$_listitemObserver;
//  Add the translations.
(0, $a5b9348af8ea14c1$export$2e2bcd8739ae039)();
class $52a95b04b2a63e73$export$2e2bcd8739ae039 {
    /**
     * Create a mobile menu.
     * @param {HTMLElement|string} 	menu		The menu node.
     * @param {object} 				[option]	Options for the menu.
     * @param {object} 				[configs]	Configuration options for the menu.
     */ constructor(menu, options, configs){
        /** MutationObserver for adding a listview to a panel. */ $52a95b04b2a63e73$var$_panelObserver.set(this, void 0);
        /** MutationObserver for adding a listitem to a listview. */ $52a95b04b2a63e73$var$_listviewObserver.set(this, void 0);
        /** MutationObserver for adding a listview to a listitem. */ $52a95b04b2a63e73$var$_listitemObserver.set(this, void 0);
        //	Extend options and configuration from defaults.
        this.opts = (0, $9873b750a4e3050d$export$8b58be045bf06082)(options, (0, $00e8806cc73bef1a$export$2e2bcd8739ae039));
        this.conf = (0, $9873b750a4e3050d$export$8b58be045bf06082)(configs, (0, $95ac14b6bfd84d23$export$2e2bcd8739ae039));
        //	Methods to expose in the API.
        this._api = [
            'i18n',
            'bind',
            'openPanel',
            'closePanel',
            'setSelected'
        ];
        //	Storage objects for nodes and hooks.
        this.node = {};
        this.hook = {};
        //	Get menu node from string or element.
        this.node.menu = typeof menu == 'string' ? document.querySelector(menu) : menu;
        if (typeof this._deprecatedWarnings == 'function') this._deprecatedWarnings();
        this.trigger('init:before');
        this._initObservers();
        this._initAddons();
        this._initHooks();
        this._initAPI();
        this._initMenu();
        this._initPanels();
        this._initOpened();
        $539d76ccec06870f$export$3db5d71bdb2d5499();
        this.trigger('init:after');
        return this;
    }
    /**
     * Open a panel.
     * @param {HTMLElement} panel               Panel to open.
     * @param {boolean}     [animation=true]    Whether or not to use an animation.
     * @param {boolean}     [setfocus=true]     Whether or not to set focus to the panel.
     */ openPanel(panel, animation = true, setfocus = true) {
        //	Find panel.
        if (!panel) return;
        panel = panel.closest('.mm-panel');
        //	Invoke "before" hook.
        this.trigger('openPanel:before', [
            panel,
            {
                animation: animation,
                setfocus: setfocus
            }
        ]);
        /** Wrapping listitem (for a vertical panel) */ const listitem = panel.closest('.mm-listitem--vertical');
        //	Open a "vertical" panel.
        if (listitem) {
            listitem.classList.add('mm-listitem--opened');
            /** The parent panel */ const parent = listitem.closest('.mm-panel');
            this.openPanel(parent);
        //	Open a "horizontal" panel.
        } else {
            /** Currently opened panel. */ const current = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
            //  Ensure current panel stays on top while closing it.
            if (panel.matches('.mm-panel--parent') && current) current.classList.add('mm-panel--highest');
            //  Remove opened, parent, animation and highest classes from all panels.
            const remove = [
                'mm-panel--opened',
                'mm-panel--parent'
            ];
            const add = [];
            if (animation) remove.push('mm-panel--noanimation');
            else add.push('mm-panel--noanimation');
            $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel').forEach((pnl)=>{
                pnl.classList.add(...add);
                pnl.classList.remove(...remove);
                if (pnl !== current) pnl.classList.remove('mm-panel--highest');
                // Set inert attribute.
                if (pnl === panel) pnl.removeAttribute('inert');
                else pnl.setAttribute('inert', 'true');
            });
            //  Open new panel.
            panel.classList.add('mm-panel--opened');
            /** The parent panel */ let parent = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${panel.dataset.mmParent}`)[0];
            //	Set parent panels as "parent".
            while(parent){
                parent = parent.closest('.mm-panel');
                parent.classList.add('mm-panel--parent');
                parent = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${parent.dataset.mmParent}`)[0];
            }
        }
        //	Invoke "after" hook.
        this.trigger('openPanel:after', [
            panel,
            {
                animation: animation,
                setfocus: setfocus
            }
        ]);
    }
    /**
     * Close a panel.
     * @param {HTMLElement} panel               Panel to close.
     * @param {boolean}     [animation=true]    Whether or not to use an animation.
     * @param {boolean}     [setfocus=true]     Whether or not to set focus to the panel.
     */ closePanel(panel, animation = true, setfocus = true) {
        if (!panel) return;
        if (!panel.matches('.mm-panel--opened') && !panel.parentElement.matches('.mm-listitem--opened')) return;
        //	Invoke "before" hook.
        this.trigger('closePanel:before', [
            panel
        ]);
        //	Close a "vertical" panel.
        if (panel.parentElement.matches('.mm-listitem--vertical')) panel.parentElement.classList.remove('mm-listitem--opened');
        else //  ... open its parent...
        if (panel.dataset.mmParent) {
            const parent = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${panel.dataset.mmParent}`)[0];
            this.openPanel(parent, animation, setfocus);
        // ... or the last opened
        } else {
            const lastPanel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--parent').pop();
            if (lastPanel && lastPanel !== panel) this.openPanel(lastPanel, animation, setfocus);
            else {
                const firstPanel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel')[0];
                if (firstPanel && firstPanel !== panel) this.openPanel(firstPanel, animation, setfocus);
            }
        }
        //	Invoke "after" hook.
        this.trigger('closePanel:after', [
            panel
        ]);
    }
    /**
     * Toggle a panel opened/closed.
     * @param {HTMLElement} panel Panel to open or close.
     */ togglePanel(panel) {
        const listitem = panel.parentElement;
        /** The function to invoke (open or close). */ let fn = 'openPanel';
        //	Toggle only works for "vertical" panels.
        if (listitem.matches('.mm-listitem--opened') || panel.matches('.mm-panel--opened')) fn = 'closePanel';
        this[fn](panel);
    }
    /**
     * Display a listitem as being "selected".
     * @param {HTMLElement} listitem Listitem to mark.
     */ setSelected(listitem) {
        //	Invoke "before" hook.
        this.trigger('setSelected:before', [
            listitem
        ]);
        //	Remove the selected class from all listitems.
        $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, '.mm-listitem--selected').forEach((li)=>{
            li.classList.remove('mm-listitem--selected');
        });
        //	Add the selected class to the provided listitem.
        listitem.classList.add('mm-listitem--selected');
        //	Invoke "after" hook.
        this.trigger('setSelected:after', [
            listitem
        ]);
    }
    /**
     * Bind functions to a hook (subscriber).
     * @param {string} 		hook The hook.
     * @param {function} 	func The function.
     */ bind(hook, func) {
        //	Create an array for the hook if it does not yet excist.
        this.hook[hook] = this.hook[hook] || [];
        //	Push the function to the array.
        this.hook[hook].push(func);
    }
    /**
     * Invoke the functions bound to a hook (publisher).
     * @param {string} 	hook  	The hook.
     * @param {array}	[args] 	Arguments for the function.
     */ trigger(hook, args) {
        if (this.hook[hook]) for(var h = 0, l = this.hook[hook].length; h < l; h++)this.hook[hook][h].apply(this, args);
    }
    /**
     * Create the observers.
     */ _initObservers() {
        $52a95b04b2a63e73$var$__classPrivateFieldSet(this, $52a95b04b2a63e73$var$_panelObserver, new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                mutation.addedNodes.forEach((listview)=>{
                    if (listview.matches(this.conf.panelNodetype.join(', '))) this._initListview(listview);
                });
            });
        }));
        $52a95b04b2a63e73$var$__classPrivateFieldSet(this, $52a95b04b2a63e73$var$_listviewObserver, new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                mutation.addedNodes.forEach((listitem)=>{
                    this._initListitem(listitem);
                });
            });
        }));
        $52a95b04b2a63e73$var$__classPrivateFieldSet(this, $52a95b04b2a63e73$var$_listitemObserver, new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                mutation.addedNodes.forEach((subpanel)=>{
                    if (subpanel === null || subpanel === void 0 ? void 0 : subpanel.matches(this.conf.panelNodetype.join(', '))) this._initSubPanel(subpanel);
                });
            });
        }));
    }
    /**
     * Create the API.
     */ _initAPI() {
        //	We need this=that because:
        //	1) the "arguments" object can not be referenced in an arrow function in ES3 and ES5.
        const that = this;
        this.API = {};
        this._api.forEach((fn)=>{
            this.API[fn] = function() {
                return that[fn].apply(that, arguments); // 1)
            };
        });
        //	Store the API in the HTML node for external usage.
        this.node.menu['mmApi'] = this.API;
    }
    /**
     * Bind the hooks specified in the options (publisher).
     */ _initHooks() {
        for(let hook in this.opts.hooks)this.bind(hook, this.opts.hooks[hook]);
    }
    /**
     * Initialize all available add-ons.
     */ _initAddons() {
        //	Invoke "before" hook.
        this.trigger('initAddons:before');
        for(let addon in $52a95b04b2a63e73$export$2e2bcd8739ae039.addons)$52a95b04b2a63e73$export$2e2bcd8739ae039.addons[addon].call(this);
        //	Invoke "after" hook.
        this.trigger('initAddons:after');
    }
    /**
     * Initialize the menu.
     */ _initMenu() {
        //	Invoke "before" hook.
        this.trigger('initMenu:before');
        //	Add class to the wrapper.
        this.node.wrpr = this.node.wrpr || this.node.menu.parentElement;
        this.node.wrpr.classList.add('mm-wrapper');
        //	Add class to the menu.
        this.node.menu.classList.add('mm-menu');
        //	Add an ID to the menu if it does not yet have one.
        this.node.menu.id = this.node.menu.id || (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
        this.node.menu.setAttribute('aria-label', this.i18n(this.opts.navbar.title || 'Menu'));
        this.node.menu.setAttribute('aria-modal', 'true');
        this.node.menu.setAttribute('role', 'dialog');
        /** All panel nodes in the menu. */ const panels = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.menu).filter((panel)=>panel.matches(this.conf.panelNodetype.join(', ')));
        //	Wrap the panels in a node.
        this.node.pnls = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-panels');
        this.node.menu.append(this.node.pnls);
        //  Initiate all panel like nodes
        panels.forEach((panel)=>{
            this._initPanel(panel);
        });
        //	Invoke "after" hook.
        this.trigger('initMenu:after');
    }
    /**
     * Initialize panels.
     */ _initPanels() {
        //	Invoke "before" hook.
        this.trigger('initPanels:before');
        //	Open / close panels.
        this.node.menu.addEventListener('click', (event)=>{
            var _a, _b;
            /** The href attribute for the clicked anchor. */ const href = ((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a[href]')) === null || _b === void 0 ? void 0 : _b.getAttribute('href')) || '';
            if (href.slice(0, 1) === '#') try {
                /** The targeted panel */ const panel = $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, href)[0];
                if (panel) {
                    event.preventDefault();
                    this.togglePanel(panel);
                }
            } catch (err) {}
        }, {
            // useCapture to ensure the logical order.
            capture: true
        });
        //	Invoke "after" hook.
        this.trigger('initPanels:after');
    }
    /**
     * Initialize a single panel.
     * @param  {HTMLElement} 		panel 	Panel to initialize.
     * @return {HTMLElement|null} 			Initialized panel.
     */ _initPanel(panel) {
        var _a;
        if (panel.matches('.mm-panel')) return;
        //	Refactor panel classnames
        $c9efe65a4853959a$export$9604f4b73fb157f3(panel, this.conf.classNames.panel, 'mm-panel');
        $c9efe65a4853959a$export$9604f4b73fb157f3(panel, this.conf.classNames.nopanel, 'mm-nopanel');
        //	Stop if not supposed to be a panel.
        if (panel.matches('.mm-nopanel')) return;
        //	Invoke "before" hook.
        this.trigger('initPanel:before', [
            panel
        ]);
        //  Must have an ID
        panel.id = panel.id || (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
        //	Wrap UL/OL in DIV
        if (panel.matches('ul, ol')) {
            /** The panel. */ const wrapper = $c9efe65a4853959a$export$185802fd694ee1f5('div');
            //  Transport the ID
            wrapper.id = panel.id;
            panel.removeAttribute('id');
            //  Transport "mm-" prefixed classnames.
            [].slice.call(panel.classList).filter((classname)=>classname.slice(0, 3) === 'mm-').forEach((classname)=>{
                wrapper.classList.add(classname);
                panel.classList.remove(classname);
            });
            //  Transport "mm" prefixed data attributes.
            Object.keys(panel.dataset).filter((attr)=>attr.slice(0, 2) === 'mm').forEach((attr)=>{
                wrapper.dataset[attr] = panel.dataset[attr];
                delete panel.dataset[attr];
            });
            //	Wrap the listview in the panel.
            panel.before(wrapper);
            wrapper.append(panel);
            panel = wrapper;
        }
        panel.classList.add('mm-panel');
        //  Append to the panels node if not vertically expanding
        if (!((_a = panel.parentElement) === null || _a === void 0 ? void 0 : _a.matches('.mm-listitem--vertical'))) this.node.pnls.append(panel);
        //  Initialize tha navbar.
        this._initNavbar(panel);
        //  Initialize the listview(s).
        $c9efe65a4853959a$export$bacb5cc5a11aef16(panel, 'ul, ol').forEach((listview)=>{
            this._initListview(listview);
        });
        // Observe the panel for added listviews.
        $52a95b04b2a63e73$var$__classPrivateFieldGet(this, $52a95b04b2a63e73$var$_panelObserver).observe(panel, {
            childList: true
        });
        //	Invoke "after" hook.
        this.trigger('initPanel:after', [
            panel
        ]);
        return panel;
    }
    /**
     * Initialize a navbar.
     * @param {HTMLElement} panel Panel for the navbar.
     */ _initNavbar(panel) {
        //	Only one navbar per panel.
        if ($c9efe65a4853959a$export$bacb5cc5a11aef16(panel, '.mm-navbar').length) return;
        /** The parent listitem. */ let parentListitem = null;
        /** The parent panel. */ let parentPanel = null;
        //  The parent listitem and parent panel
        if (panel.dataset.mmParent) {
            parentListitem = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${panel.dataset.mmParent}`)[0];
            parentPanel = parentListitem.closest('.mm-panel');
            while(parentPanel.closest('.mm-listitem--vertical'))parentPanel = parentPanel.parentElement.closest('.mm-panel');
        }
        //  No navbar needed for vertical submenus.
        if (parentListitem === null || parentListitem === void 0 ? void 0 : parentListitem.matches('.mm-listitem--vertical')) return;
        //	Invoke "before" hook.
        this.trigger('initNavbar:before', [
            panel
        ]);
        /** The navbar element. */ const navbar = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-navbar');
        //  Hide navbar if specified in options.
        if (!this.opts.navbar.add) navbar.classList.add('mm-hidden');
        //  Add the back button.
        if (parentPanel) {
            /** The back button. */ const prev = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-btn.mm-btn--prev.mm-navbar__btn');
            prev.href = `#${parentPanel.id}`;
            prev.setAttribute('aria-label', this.i18n(this.conf.screenReader.closeSubmenu));
            navbar.append(prev);
        }
        /** The anchor that opens the panel. */ let opener = null;
        //  The anchor is in a listitem.
        if (parentListitem) opener = $c9efe65a4853959a$export$bacb5cc5a11aef16(parentListitem, '.mm-listitem__text')[0];
        else if (parentPanel) opener = $c9efe65a4853959a$export$71aa6c912b956294(parentPanel, 'a[href="#' + panel.id + '"]')[0];
        //  Add the title.
        /** The title */ const title = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-navbar__title');
        title.tabIndex = -1;
        title.setAttribute('aria-hidden', 'true');
        switch(this.opts.navbar.titleLink){
            case 'anchor':
                if (opener) title.href = opener.getAttribute('href');
                break;
            case 'parent':
                if (parentPanel) title.href = `#${parentPanel.id}`;
                break;
        }
        /** Text in the title */ const titleText = $c9efe65a4853959a$export$185802fd694ee1f5('span');
        titleText.innerHTML = panel.dataset.mmTitle || $c9efe65a4853959a$export$b3ad2b0b0d33f91a(opener) || this.i18n(this.opts.navbar.title || 'Menu');
        //  Add to DOM
        panel.prepend(navbar);
        navbar.append(title);
        title.append(titleText);
        //	Invoke "after" hook.
        this.trigger('initNavbar:after', [
            panel
        ]);
    }
    /**
     * Initialize a listview.
     * @param {HTMLElement} listview Listview to initialize.
     */ _initListview(listview) {
        //  Assert UL
        if (![
            'htmlulistelement',
            'htmlolistelement'
        ].includes((0, $9873b750a4e3050d$export$bf9fb029d174d554)(listview))) return;
        if (listview.matches('.mm-listview')) return;
        $c9efe65a4853959a$export$9604f4b73fb157f3(listview, this.conf.classNames.nolistview, 'mm-nolistview');
        if (listview.matches('.mm-nolistview')) return;
        //	Invoke "before" hook.
        this.trigger('initListview:before', [
            listview
        ]);
        listview.classList.add('mm-listview');
        //  Initiate the listitem(s).
        $c9efe65a4853959a$export$bacb5cc5a11aef16(listview).forEach((listitem)=>{
            this._initListitem(listitem);
        });
        // Observe the listview for added listitems.
        $52a95b04b2a63e73$var$__classPrivateFieldGet(this, $52a95b04b2a63e73$var$_listviewObserver).observe(listview, {
            childList: true
        });
        //	Invoke "after" hook.
        this.trigger('initListview:after', [
            listview
        ]);
    }
    /**
     * Initialte a listitem.
     * @param {HTMLElement} listitem Listitem to initiate.
     */ _initListitem(listitem) {
        //  Assert LI
        if (![
            'htmllielement'
        ].includes((0, $9873b750a4e3050d$export$bf9fb029d174d554)(listitem))) return;
        if (listitem.matches('.mm-listitem')) return;
        $c9efe65a4853959a$export$9604f4b73fb157f3(listitem, this.conf.classNames.divider, 'mm-divider');
        if (listitem.matches('.mm-divider')) return;
        //	Invoke "before" hook.
        this.trigger('initListitem:before', [
            listitem
        ]);
        listitem.classList.add('mm-listitem');
        $c9efe65a4853959a$export$9604f4b73fb157f3(listitem, this.conf.classNames.selected, 'mm-listitem--selected');
        $c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, 'a, span').forEach((text)=>{
            text.classList.add('mm-listitem__text');
        });
        //  Initiate the subpanel.
        $c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, this.conf.panelNodetype.join(', ')).forEach((subpanel)=>{
            this._initSubPanel(subpanel);
        });
        // Observe the listitem for added listviews.
        $52a95b04b2a63e73$var$__classPrivateFieldGet(this, $52a95b04b2a63e73$var$_listitemObserver).observe(listitem, {
            childList: true
        });
        //	Invoke "after" hook.
        this.trigger('initListitem:after', [
            listitem
        ]);
    }
    /**
     * Initiate a subpanel.
     * @param {HTMLElement} subpanel Subpanel to initiate.
     */ _initSubPanel(subpanel) {
        if (subpanel.matches('.mm-panel')) return;
        /** The parent element for the panel. */ const listitem = subpanel.parentElement;
        /** Whether or not the listitem expands vertically */ const vertical = subpanel.matches('.' + this.conf.classNames.vertical) || !this.opts.slidingSubmenus;
        // Make it expand vertically
        if (vertical) listitem.classList.add('mm-listitem--vertical');
        //  Force an ID
        listitem.id = listitem.id || (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
        subpanel.id = subpanel.id || (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
        //  Store parent/child relation
        listitem.dataset.mmChild = subpanel.id;
        subpanel.dataset.mmParent = listitem.id;
        /** The open link. */ let button = $c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, '.mm-btn')[0];
        //  Init item text
        if (!button) {
            button = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-btn.mm-btn--next.mm-listitem__btn');
            $c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, 'a, span').forEach((text)=>{
                //  If the item has no link,
                //      Replace the item with the open link.
                if (text.matches('span')) {
                    button.classList.add('mm-listitem__text');
                    button.innerHTML = text.innerHTML;
                    listitem.insertBefore(button, text.nextElementSibling);
                    text.remove();
                } else listitem.insertBefore(button, text.nextElementSibling);
            });
            button.setAttribute('aria-label', this.i18n(this.conf.screenReader[listitem.matches('.mm-listitem--vertical') ? 'toggleSubmenu' : 'openSubmenu']));
        }
        button.href = `#${subpanel.id}`;
        this._initPanel(subpanel);
    }
    /**
     * Find and open the correct panel after creating the menu.
     */ _initOpened() {
        //	Invoke "before" hook.
        this.trigger('initOpened:before');
        /** The selected listitem(s). */ const listitem = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, '.mm-listitem--selected').pop();
        /**	The current opened panel. */ let panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel')[0];
        if (listitem) {
            this.setSelected(listitem);
            panel = listitem.closest('.mm-panel');
        }
        //	Open the current opened panel.
        this.openPanel(panel, false, false);
        //	Invoke "after" hook.
        this.trigger('initOpened:after');
    }
    /**
     * Get the translation for a text.
     * @param  {string}     text 	Text to translate.
     * @return {string}		        The translated text.
     */ i18n(text) {
        return $17526d088c38b2ee$export$3988ae62b71be9a3(text, this.conf.language);
    }
    /**
     * Get all translations for the given language.
     * @return {object}	The translations.
     */ static i18n(text = {}, language = '') {
        if (text && language) $17526d088c38b2ee$export$e16d8520af44a096(text, language);
        else return $17526d088c38b2ee$export$57bf213be019eeb0();
    }
}
$52a95b04b2a63e73$var$_panelObserver = new WeakMap(), $52a95b04b2a63e73$var$_listviewObserver = new WeakMap(), $52a95b04b2a63e73$var$_listitemObserver = new WeakMap();
/**	Available add-ons for the plugin. */ $52a95b04b2a63e73$export$2e2bcd8739ae039.addons = {};
/**	Globally used HTML elements. */ $52a95b04b2a63e73$export$2e2bcd8739ae039.node = {};
/** Globally used v. */ $52a95b04b2a63e73$export$2e2bcd8739ae039.vars = {};



const $bea0bc1f5f02d3e7$var$options = {
    use: true,
    position: 'left'
};
var $bea0bc1f5f02d3e7$export$2e2bcd8739ae039 = $bea0bc1f5f02d3e7$var$options;


const $cdb5329c4ae53746$var$configs = {
    clone: false,
    menu: {
        insertMethod: 'append',
        insertSelector: 'body'
    },
    page: {
        nodetype: 'div',
        selector: null,
        noSelector: []
    },
    screenReader: {
        closeMenu: 'Close menu',
        openMenu: 'Open menu'
    }
};
var $cdb5329c4ae53746$export$2e2bcd8739ae039 = $cdb5329c4ae53746$var$configs;




const $add3d3efdc58e6a9$var$possiblePositions = [
    'left',
    'left-front',
    'right',
    'right-front',
    'top',
    'bottom'
];
function $add3d3efdc58e6a9$export$2e2bcd8739ae039() {
    this.opts.offCanvas = this.opts.offCanvas || {};
    this.conf.offCanvas = this.conf.offCanvas || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.offCanvas, (0, $bea0bc1f5f02d3e7$export$2e2bcd8739ae039));
    const configs = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.conf.offCanvas, (0, $cdb5329c4ae53746$export$2e2bcd8739ae039));
    if (!options.use) return;
    if (!$add3d3efdc58e6a9$var$possiblePositions.includes(options.position)) options.position = $add3d3efdc58e6a9$var$possiblePositions[0];
    //	Add methods to the API.
    this._api.push('open', 'close', 'setPage', 'position');
    //  Clone menu if needed.
    if (configs.clone) {
        //	Clone the original menu and store it.
        this.node.menu = this.node.menu.cloneNode(true);
        //	Prefix all ID's in the cloned menu.
        if (this.node.menu.id) this.node.menu.id = (0, $9873b750a4e3050d$export$e901557d2458811)(this.node.menu.id);
        $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, '[id]').forEach((elem)=>{
            elem.id = (0, $9873b750a4e3050d$export$e901557d2458811)(elem.id);
        });
    }
    //  Prepend the menu to the <body>.
    this.bind('initMenu:before', ()=>{
        this.node.wrpr = document.querySelector(configs.menu.insertSelector);
        this.node.wrpr[configs.menu.insertMethod](this.node.menu);
    });
    //	Setup the UI blocker.
    if (!(0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.blck) this.bind('initMenu:before', ()=>{
        /** The UI blocker node. */ const blocker = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-wrapper__blocker.mm-blocker.mm-slideout');
        blocker.id = (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
        blocker.setAttribute('aria-label', this.i18n(configs.screenReader.closeMenu));
        blocker.setAttribute('inert', 'true');
        //	Append the blocker node to the body.
        document.querySelector(configs.menu.insertSelector).append(blocker);
        //	Store the blocker node.
        (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.blck = blocker;
    });
    this.bind('initMenu:after', ()=>{
        //	Setup the page.
        this.setPage((0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page);
        //	Setup the menu.
        this.node.menu.classList.add('mm-menu--offcanvas');
        this.node.menu.setAttribute('inert', 'true');
        if ($add3d3efdc58e6a9$var$possiblePositions.includes(options.position)) {
            this.node.wrpr.classList.add(`mm-wrapper--position-${options.position}`);
            this.node.menu.classList.add(`mm-menu--position-${options.position}`);
        }
        //	Open if url hash equals menu id (usefull when user clicks the hamburger icon before the menu is created)
        let hash = window.location.hash;
        if (hash) {
            let id = (0, $9873b750a4e3050d$export$77c7ff3a98df843b)(this.node.menu.id);
            if (id && id == hash.slice(1)) setTimeout(()=>{
                this.open();
            }, 1000);
        }
    });
    //	Open / close the menu.
    document.addEventListener('click', (event)=>{
        var _a;
        /** THe href attribute for the clicked anchor. */ const href = (_a = event.target.closest('a')) === null || _a === void 0 ? void 0 : _a.getAttribute('href');
        switch(href){
            //	Open menu if the clicked anchor links to the menu.
            case `#${(0, $9873b750a4e3050d$export$77c7ff3a98df843b)(this.node.menu.id)}`:
                event.preventDefault();
                this.open();
                break;
            //	Close menu if the clicked anchor links to the page.
            case `#${(0, $9873b750a4e3050d$export$77c7ff3a98df843b)((0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page.id)}`:
                event.preventDefault();
                this.close();
                break;
        }
    });
    //	Close the menu with ESC key.
    document.addEventListener('keyup', (event)=>{
        if (event.key == 'Escape') this.close();
    });
}
/**
 * Open the menu.
 */ (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).prototype.open = function() {
    if (this.node.menu.matches('.mm-menu--opened')) return;
    //	Invoke "before" hook.
    this.trigger('open:before');
    //	Open
    this.node.wrpr.classList.add('mm-wrapper--opened', `mm-wrapper--position-${this.opts.offCanvas.position}`);
    this.node.menu.classList.add('mm-menu--opened');
    this.node.menu.removeAttribute('inert');
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.blck.removeAttribute('inert');
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page.setAttribute('inert', 'true');
    //  Store the last focesed element.
    this.node.open = document.activeElement;
    //	Invoke "after" hook.
    this.trigger('open:after');
};
/**
 * Close the menu.
 */ (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).prototype.close = function() {
    var _a;
    if (!this.node.menu.matches('.mm-menu--opened')) return;
    //	Invoke "before" hook.
    this.trigger('close:before');
    this.node.wrpr.classList.remove('mm-wrapper--opened', `mm-wrapper--position-${this.opts.offCanvas.position}`);
    this.node.menu.classList.remove('mm-menu--opened');
    this.node.menu.setAttribute('inert', 'true');
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.blck.setAttribute('inert', 'true');
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
    /** Element to focus. */ const focus = this.node.open || document.querySelector(`[href="#${this.node.menu.id}"]`) || null;
    (_a = focus) === null || _a === void 0 || _a.focus();
    // Prevent html/body from scrolling due to focus.
    document.body.scrollLeft = 0;
    document.documentElement.scrollLeft = 0;
    //	Invoke "after" hook.
    this.trigger('close:after');
};
/**
 * Set the "page" node.
 *
 * @param {HTMLElement} page Element to set as the page.
 */ (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).prototype.setPage = function(page) {
    /** Offcanvas config */ const configs = this.conf.offCanvas;
    //	If no page was specified, find it.
    if (!page) {
        /** Array of elements that are / could be "the page". */ let pages = typeof configs.page.selector == 'string' ? $c9efe65a4853959a$export$71aa6c912b956294(document.body, configs.page.selector) : $c9efe65a4853959a$export$bacb5cc5a11aef16(document.body, configs.page.nodetype);
        //	Filter out elements that are absolutely not "the page".
        pages = pages.filter((page)=>!page.matches('.mm-menu, .mm-wrapper__blocker'));
        //	Filter out elements that are configured to not be "the page".
        if (configs.page.noSelector.length) pages = pages.filter((page)=>!page.matches(configs.page.noSelector.join(', ')));
        //	Wrap multiple pages in a single element.
        if (pages.length > 1) {
            let wrapper = $c9efe65a4853959a$export$185802fd694ee1f5('div');
            pages[0].before(wrapper);
            pages.forEach((page)=>{
                wrapper.append(page);
            });
            pages = [
                wrapper
            ];
        }
        page = pages[0];
    }
    //	Invoke "before" hook.
    this.trigger('setPage:before', [
        page
    ]);
    //  Set the classes
    page.classList.add('mm-page', 'mm-slideout');
    //  Set the ID.
    page.id = page.id || (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
    //	Sync the blocker to target the page.
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.blck.setAttribute('href', `#${page.id}`);
    //	Store the page node.
    (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page = page;
    //	Invoke "after" hook.
    this.trigger('setPage:after', [
        page
    ]);
};


const $4b56e9db5696bd70$var$options = {
    fix: true
};
var $4b56e9db5696bd70$export$2e2bcd8739ae039 = $4b56e9db5696bd70$var$options;



/** Whether or not touch gestures are supported by the browser. */ const $e4362909c85b6c54$export$d0b7ea69ab6056df = 'ontouchstart' in window || (navigator.msMaxTouchPoints ? true : false) || false;



function $9980f7c0a55fda66$export$2e2bcd8739ae039() {
    //	The scrollBugFix add-on fixes a scrolling bug
    //		1) on touch devices
    //		2) in an off-canvas menu
    if (!$e4362909c85b6c54$export$d0b7ea69ab6056df || // 1
    !this.opts.offCanvas.use // 2
    ) return;
    this.opts.scrollBugFix = this.opts.scrollBugFix || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.scrollBugFix, (0, $4b56e9db5696bd70$export$2e2bcd8739ae039));
    if (!options.fix) return;
    /** The touch-direction instance. */ const touchDir = (0, $9873b750a4e3050d$export$c69521134f103c95)(this.node.menu);
    //  Prevent the page from scrolling when scrolling in the menu.
    this.node.menu.addEventListener('scroll', (evnt)=>{
        evnt.preventDefault();
        evnt.stopPropagation();
    }, {
        //  Make sure to tell the browser the event will be prevented.
        passive: false
    });
    //  Prevent the page from scrolling when dragging in the menu.
    this.node.menu.addEventListener('touchmove', (evnt)=>{
        let wrapper = evnt.target.closest('.mm-panel, .mm-iconbar__top, .mm-iconbar__bottom');
        if (wrapper && wrapper.closest('.mm-listitem--vertical')) wrapper = $c9efe65a4853959a$export$7901f6cd558b9a93(wrapper, '.mm-panel').pop();
        if (wrapper) {
            //  When dragging a non-scrollable panel/iconbar,
            //      we can simply stopPropagation.
            if (wrapper.scrollHeight === wrapper.offsetHeight) evnt.stopPropagation();
            else if (//  When scrolled up and dragging down
            wrapper.scrollTop == 0 && touchDir.get() == 'down' || //  When scrolled down and dragging up
            wrapper.scrollHeight == wrapper.scrollTop + wrapper.offsetHeight && touchDir.get() == 'up') evnt.stopPropagation();
        //  When dragging anything other than a panel/iconbar.
        } else evnt.stopPropagation();
    }, {
        //  Make sure to tell the browser the event can be prevented.
        passive: false
    });
    //  Some small additional improvements
    //	Scroll the current opened panel to the top when opening the menu.
    this.bind('open:after', ()=>{
        var panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
        if (panel) panel.scrollTop = 0;
    });
    //	Fix issue after device rotation change.
    window.addEventListener('orientationchange', (evnt)=>{
        var panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
        if (panel) {
            panel.scrollTop = 0;
            //	Apparently, changing the overflow-scrolling property triggers some event :)
            panel.style['-webkit-overflow-scrolling'] = 'auto';
            panel.style['-webkit-overflow-scrolling'] = 'touch';
        }
    });
}



const $87b137b5fb73cb90$var$options = 'light';
var $87b137b5fb73cb90$export$2e2bcd8739ae039 = $87b137b5fb73cb90$var$options;


/** A list of available themes. */ const $b1dfd79d2c8ad54f$var$possibleThemes = [
    'light',
    'dark',
    'white',
    'black',
    'light-contrast',
    'dark-contrast',
    'white-contrast',
    'black-contrast'
];
function $b1dfd79d2c8ad54f$export$2e2bcd8739ae039() {
    this.opts.theme = this.opts.theme || (0, $87b137b5fb73cb90$export$2e2bcd8739ae039);
    const theme = this.opts.theme;
    if (!$b1dfd79d2c8ad54f$var$possibleThemes.includes(theme)) this.opts.theme = $b1dfd79d2c8ad54f$var$possibleThemes[0];
    this._api.push('theme');
    this.bind('initMenu:after', ()=>{
        this.theme(this.opts.theme);
    });
}
/**
 * Get or set the theme for the menu.
 *
 * @param {string} [position] The theme for the menu.
 */ (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).prototype.theme = function(theme = null) {
    /** The previously used theme */ const oldTheme = this.opts.theme;
    if (theme) {
        if ($b1dfd79d2c8ad54f$var$possibleThemes.includes(theme)) {
            this.node.menu.classList.remove(`mm-menu--theme-${oldTheme}`);
            this.node.menu.classList.add(`mm-menu--theme-${theme}`);
            this.opts.theme = theme;
        }
    } else return oldTheme;
};


const $2f5cdcdc3e82ce92$var$options = {
    close: false,
    open: false
};
var $2f5cdcdc3e82ce92$export$2e2bcd8739ae039 = $2f5cdcdc3e82ce92$var$options;




function $8453c4a8b7caaa18$export$2e2bcd8739ae039() {
    this.opts.backButton = this.opts.backButton || {};
    if (!this.opts.offCanvas.use) return;
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.backButton, (0, $2f5cdcdc3e82ce92$export$2e2bcd8739ae039));
    const _menu = `#${this.node.menu.id}`;
    //	Close menu
    if (options.close) {
        let states = [];
        const setStates = ()=>{
            states = [
                _menu
            ];
            $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened, .mm-panel--parent').forEach((panel)=>{
                states.push('#' + panel.id);
            });
        };
        this.bind('open:after', ()=>{
            history.pushState(null, '', location.pathname + location.search + _menu);
        });
        this.bind('open:after', setStates);
        this.bind('openPanel:after', setStates);
        this.bind('close:after', ()=>{
            states = [];
            history.back();
            history.pushState(null, '', location.pathname + location.search);
        });
        window.addEventListener('popstate', ()=>{
            if (this.node.menu.matches('.mm-menu--opened')) {
                if (states.length) {
                    states = states.slice(0, -1);
                    const hash = states[states.length - 1];
                    if (hash == _menu) this.close();
                    else {
                        this.openPanel(this.node.menu.querySelector(hash));
                        history.pushState(null, '', location.pathname + location.search + _menu);
                    }
                }
            }
        });
    }
    if (options.open) window.addEventListener('popstate', (evnt)=>{
        if (!this.node.menu.matches('.mm-menu--opened') && location.hash == _menu) this.open();
    });
}


const $a092872d05e9f1ee$var$options = {
    add: false
};
var $a092872d05e9f1ee$export$2e2bcd8739ae039 = $a092872d05e9f1ee$var$options;




function $e7deeb5738786d8d$export$2e2bcd8739ae039() {
    this.opts.counters = this.opts.counters || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.counters, (0, $a092872d05e9f1ee$export$2e2bcd8739ae039));
    if (!options.add) return;
    /**
     * Counting the visible listitems and setting it to the counter element.
     * @param {HTMLElement} panel Panel to count LIs in.
     */ const count = (panel)=>{
        /** Parent panel for the mutated listitem. */ const parent = this.node.pnls.querySelector(`#${panel.dataset.mmParent}`);
        if (!parent) return;
        /** The counter for the listitem. */ const counter = parent.querySelector('.mm-counter');
        if (!counter) return;
        /** The listitems */ const listitems = [];
        $c9efe65a4853959a$export$bacb5cc5a11aef16(panel, '.mm-listview').forEach((listview)=>{
            listitems.push(...$c9efe65a4853959a$export$bacb5cc5a11aef16(listview, '.mm-listitem'));
        });
        counter.innerHTML = $c9efe65a4853959a$export$72ac92c27fa3be94(listitems).length.toString();
    };
    /** Mutation observer the the listitems. */ const listitemObserver = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((mutation)=>{
            if (mutation.attributeName == 'class') count(mutation.target.closest('.mm-panel'));
        });
    });
    //	Add the counters after a listview is initiated.
    this.bind('initListview:after', (listview)=>{
        /** The panel where the listview is in. */ const panel = listview.closest('.mm-panel');
        /** The parent LI for the panel */ const parent = this.node.pnls.querySelector(`#${panel.dataset.mmParent}`);
        if (!parent) return;
        /** The button inside the parent LI */ const button = $c9efe65a4853959a$export$bacb5cc5a11aef16(parent, '.mm-btn')[0];
        if (!button) return;
        //	Check if no counter already excists.
        if (!$c9efe65a4853959a$export$bacb5cc5a11aef16(button, '.mm-counter').length) {
            /** The counter for the listitem. */ const counter = $c9efe65a4853959a$export$185802fd694ee1f5('span.mm-counter');
            counter.setAttribute('aria-hidden', 'true');
            button.prepend(counter);
        }
        //  Count immediately.
        count(panel);
    });
    //  Count when LI classname changes.
    this.bind('initListitem:after', (listitem)=>{
        /** The panel where the listitem is in. */ const panel = listitem.closest('.mm-panel');
        if (!panel) return;
        /** The parent LI for the panel. */ const parent = this.node.pnls.querySelector(`#${panel.dataset.mmParent}`);
        if (!parent) return;
        listitemObserver.observe(listitem, {
            attributes: true
        });
    });
}


const $0c3851c9ec2b683c$var$options = {
    use: false,
    top: [],
    bottom: [],
    position: 'left',
    type: 'default'
};
var $0c3851c9ec2b683c$export$2e2bcd8739ae039 = $0c3851c9ec2b683c$var$options;





function $bc26f8a78d30aced$export$2e2bcd8739ae039() {
    this.opts.iconbar = this.opts.iconbar || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.iconbar, (0, $0c3851c9ec2b683c$export$2e2bcd8739ae039));
    if (!options.use) return;
    let iconbar;
    [
        'top',
        'bottom'
    ].forEach((position, n)=>{
        let ctnt = options[position];
        //	Extend shorthand options
        if ((0, $9873b750a4e3050d$export$bf9fb029d174d554)(ctnt) != 'array') ctnt = [
            ctnt
        ];
        //	Create node
        const part = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-iconbar__' + position);
        //	Add content
        for(let c = 0, l = ctnt.length; c < l; c++)if (typeof ctnt[c] == 'string') part.innerHTML += ctnt[c];
        else part.append(ctnt[c]);
        if (part.children.length) {
            if (!iconbar) iconbar = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-iconbar');
            iconbar.append(part);
        }
    });
    //	Add to menu
    if (iconbar) {
        //	Add the iconbar.
        this.bind('initMenu:after', ()=>{
            this.node.menu.prepend(iconbar);
        });
        //	En-/disable the iconbar.
        let classname = 'mm-menu--iconbar-' + options.position;
        let enable = ()=>{
            this.node.menu.classList.add(classname);
        };
        let disable = ()=>{
            this.node.menu.classList.remove(classname);
        };
        if (typeof options.use == 'boolean') this.bind('initMenu:after', enable);
        else $539d76ccec06870f$export$e16d8520af44a096(options.use, enable, disable);
        //	Tabs
        if (options.type == 'tabs') {
            iconbar.classList.add('mm-iconbar--tabs');
            iconbar.addEventListener('click', (evnt)=>{
                const anchor = evnt.target.closest('.mm-iconbar__tab');
                if (!anchor) return;
                if (anchor.matches('.mm-iconbar__tab--selected')) {
                    evnt.stopImmediatePropagation();
                    return;
                }
                try {
                    const panel = $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, `${anchor.getAttribute('href')}.mm-panel`)[0];
                    if (panel) {
                        evnt.preventDefault();
                        evnt.stopImmediatePropagation();
                        this.openPanel(panel, false);
                    }
                } catch (err) {}
            });
            const selectTab = (panel)=>{
                $c9efe65a4853959a$export$71aa6c912b956294(iconbar, 'a').forEach((anchor)=>{
                    anchor.classList.remove('mm-iconbar__tab--selected');
                });
                const anchor = $c9efe65a4853959a$export$71aa6c912b956294(iconbar, '[href="#' + panel.id + '"]')[0];
                if (anchor) anchor.classList.add('mm-iconbar__tab--selected');
                else {
                    const parent = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${panel.dataset.mmParent}`)[0];
                    if (parent) selectTab(parent.closest('.mm-panel'));
                }
            };
            this.bind('openPanel:before', selectTab);
        }
    }
}


const $da4131121ad1ee66$var$options = {
    add: false,
    blockPanel: true,
    visible: 3
};
var $da4131121ad1ee66$export$2e2bcd8739ae039 = $da4131121ad1ee66$var$options;




function $e91f5665a6f095f0$export$2e2bcd8739ae039() {
    this.opts.iconPanels = this.opts.iconPanels || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.iconPanels, (0, $da4131121ad1ee66$export$2e2bcd8739ae039));
    let keepFirst = false;
    if (options.visible == 'first') {
        keepFirst = true;
        options.visible = 1;
    }
    options.visible = Math.min(3, Math.max(1, options.visible));
    options.visible++;
    //	Add the iconpanels
    if (options.add) {
        this.bind('initMenu:after', ()=>{
            this.node.menu.classList.add('mm-menu--iconpanel');
        });
        /** The classnames that can be set to a panel */ const classnames = [
            'mm-panel--iconpanel-0',
            'mm-panel--iconpanel-1',
            'mm-panel--iconpanel-2',
            'mm-panel--iconpanel-3'
        ];
        //  Show only the main panel.
        if (keepFirst) this.bind('initMenu:after', ()=>{
            var _a;
            (_a = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel')[0]) === null || _a === void 0 || _a.classList.add('mm-panel--iconpanel-first');
        });
        else this.bind('openPanel:after', (panel)=>{
            //  Do nothing when opening a vertical submenu
            if (panel.closest('.mm-listitem--vertical')) return;
            let panels = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel');
            //	Filter out panels that are not opened.
            panels = panels.filter((panel)=>panel.matches('.mm-panel--parent'));
            //	Add the current panel to the list.
            panels.push(panel);
            //	Slice the opened panels to the max visible amount.
            panels = panels.slice(-options.visible);
            //	Add the "iconpanel" classnames.
            panels.forEach((panel, p)=>{
                panel.classList.remove('mm-panel--iconpanel-first', ...classnames);
                panel.classList.add(`mm-panel--iconpanel-${p}`);
            });
        });
    // this.bind('initPanel:after', (panel: HTMLElement) => {
    //     if (!panel.closest('.mm-listitem--vertical') &&
    //         !DOM.children(panel, '.mm-panel__blocker')[0]
    //     ) {
    //         const blocker = DOM.create('div.mm-blocker.mm-panel__blocker') as HTMLElement;
    //         panel.prepend(blocker);
    //     }
    // });
    }
}


const $4fcdf67dada2543a$var$configs = {
    breadcrumbs: {
        separator: '/',
        removeFirst: false
    }
};
var $4fcdf67dada2543a$export$2e2bcd8739ae039 = $4fcdf67dada2543a$var$configs;


/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */ function $256275208a499aa2$export$4f8b0ef91d76ca33(options) {
    if (typeof options == 'boolean' && options) options = {};
    if (typeof options != 'object') options = {};
    if (typeof options.content == 'undefined') options.content = [
        'prev',
        'title'
    ];
    if (!(options.content instanceof Array)) options.content = [
        options.content
    ];
    if (typeof options.use == 'undefined') options.use = true;
    return options;
}






function $ea4774f8627bdc3e$export$2e2bcd8739ae039(navbar) {
    //	Add content
    var breadcrumbs = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-navbar__breadcrumbs');
    navbar.append(breadcrumbs);
    this.bind('initNavbar:after', (panel)=>{
        if (panel.querySelector('.mm-navbar__breadcrumbs')) return;
        $c9efe65a4853959a$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].classList.add('mm-hidden');
        var crumbs = [], breadcrumbs = $c9efe65a4853959a$export$185802fd694ee1f5('span.mm-navbar__breadcrumbs'), current = panel, first = true;
        while(current){
            current = current.closest('.mm-panel');
            if (!current.parentElement.matches('.mm-listitem--vertical')) {
                let title = $c9efe65a4853959a$export$71aa6c912b956294(current, '.mm-navbar__title span')[0];
                if (title) {
                    let text = title.textContent;
                    if (text.length) crumbs.unshift(first ? `<span>${text}</span>` : `<a 
                                    href="#${current.id}" 
                                    title="${this.i18n(this.conf.screenReader.openSubmenu)}"
                                    >${text}</a>`);
                }
                first = false;
            }
            current = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${current.dataset.mmParent}`)[0];
        }
        if (this.conf.navbars.breadcrumbs.removeFirst) crumbs.shift();
        breadcrumbs.innerHTML = crumbs.join('<span class="mm-separator">' + this.conf.navbars.breadcrumbs.separator + '</span>');
        $c9efe65a4853959a$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].append(breadcrumbs);
    });
    //	Update for to opened panel
    this.bind('openPanel:before', (panel)=>{
        var crumbs = panel.querySelector('.mm-navbar__breadcrumbs');
        breadcrumbs.innerHTML = crumbs ? crumbs.innerHTML : '';
    });
}



function $f9ba9e7a7addba71$export$2e2bcd8739ae039(navbar) {
    /** The close button. */ const close = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-btn.mm-btn--close.mm-navbar__btn');
    close.setAttribute('aria-label', this.i18n(this.conf.offCanvas.screenReader.closeMenu));
    //	Add the button to the navbar.
    navbar.append(close);
    //	Update to target the page node.
    this.bind('setPage:after', (page)=>{
        close.href = `#${page.id}`;
    });
}



function $78c6b0ae03a59271$export$2e2bcd8739ae039(navbar) {
    /** The prev button. */ let prev = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-btn.mm-hidden');
    //	Add button to navbar.
    navbar.append(prev);
    //  Hide navbar in the panel.
    this.bind('initNavbar:after', (panel)=>{
        $c9efe65a4853959a$export$bacb5cc5a11aef16(panel, '.mm-navbar')[0].classList.add('mm-hidden');
    });
    // Update the button href when opening a panel.
    this.bind('openPanel:before', (panel)=>{
        if (panel.parentElement.matches('.mm-listitem--vertical')) return;
        prev.classList.add('mm-hidden');
        /** Original button in the panel. */ const original = panel.querySelector('.mm-navbar__btn.mm-btn--prev');
        if (original) {
            /** Clone of the original button in the panel. */ const clone = original.cloneNode(true);
            prev.after(clone);
            prev.remove();
            prev = clone;
        }
    });
}




function $5e2f48df181b133f$export$2e2bcd8739ae039(navbar) {
    /** Empty wrapper for the searchfield. */ let wrapper = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-navbar__searchfield');
    wrapper.id = (0, $9873b750a4e3050d$export$8b15d37bc3f197d4)();
    //	Add button to navbar.
    navbar.append(wrapper);
    this.opts.searchfield = this.opts.searchfield || {};
    this.opts.searchfield.add = true;
    this.opts.searchfield.addTo = `#${wrapper.id}`;
}



function $f2fdc36fe5adf949$export$2e2bcd8739ae039(navbar) {
    /** The title node in the navbar. */ let title = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-navbar__title');
    //	Add title to the navbar.
    navbar.append(title);
    //	Update the title to the opened panel.
    this.bind('openPanel:before', (panel)=>{
        //	Do nothing in a vertically expanding panel.
        if (panel.parentElement.matches('.mm-listitem--vertical')) return;
        /** Original title in the panel. */ const original = panel.querySelector('.mm-navbar__title');
        if (original) {
            /** Clone of the original title in the panel. */ const clone = original.cloneNode(true);
            title.after(clone);
            title.remove();
            title = clone;
        }
    });
}



function $83650a21e5ebcd56$export$2e2bcd8739ae039(navbar) {
    navbar.classList.add('mm-navbar--tabs');
    navbar.closest('.mm-navbars').classList.add('mm-navbars--has-tabs');
    $c9efe65a4853959a$export$bacb5cc5a11aef16(navbar, 'a').forEach((anchor)=>{
        anchor.classList.add('mm-navbar__tab');
    });
    /**
     * Mark a tab as selected.
     * @param {HTMLElement} panel Opened panel.
     */ function selectTab(panel) {
        /** The tab that links to the opened panel. */ const anchor = $c9efe65a4853959a$export$bacb5cc5a11aef16(navbar, `.mm-navbar__tab[href="#${panel.id}"]`)[0];
        if (anchor) {
            anchor.classList.add('mm-navbar__tab--selected');
            // @ts-ignore
            anchor.ariaExpanded = 'true';
        } else {
            /** The parent listitem. */ const parent = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${panel.dataset.mmParent}`)[0];
            if (parent) selectTab.call(this, parent.closest('.mm-panel'));
        }
    }
    this.bind('openPanel:before', (panel)=>{
        //  Remove selected class.
        $c9efe65a4853959a$export$bacb5cc5a11aef16(navbar, 'a').forEach((anchor)=>{
            anchor.classList.remove('mm-navbar__tab--selected');
            // @ts-ignore
            anchor.ariaExpanded = 'false';
        });
        selectTab.call(this, panel);
    });
    this.bind('initPanels:after', ()=>{
        //	Add animation class to panel.
        navbar.addEventListener('click', (event)=>{
            var _a, _b, _c;
            /** The href for the clicked tab. */ const href = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('.mm-navbar__tab')) === null || _b === void 0 ? void 0 : _b.getAttribute('href');
            try {
                (_c = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `${href}.mm-panel`)[0]) === null || _c === void 0 || _c.classList.add('mm-panel--noanimation');
            } catch (err) {}
        }, {
            // useCapture to ensure the logical order.
            capture: true
        });
    });
}


$396c8988d79ce9e9$export$2e2bcd8739ae039.navbarContents = {
    breadcrumbs: $ea4774f8627bdc3e$export$2e2bcd8739ae039,
    close: $f9ba9e7a7addba71$export$2e2bcd8739ae039,
    prev: $78c6b0ae03a59271$export$2e2bcd8739ae039,
    searchfield: $5e2f48df181b133f$export$2e2bcd8739ae039,
    title: $f2fdc36fe5adf949$export$2e2bcd8739ae039
};
$396c8988d79ce9e9$export$2e2bcd8739ae039.navbarTypes = {
    tabs: $83650a21e5ebcd56$export$2e2bcd8739ae039
};
function $396c8988d79ce9e9$export$2e2bcd8739ae039() {
    this.opts.navbars = this.opts.navbars || [];
    this.conf.navbars = this.conf.navbars || {};
    //	Extend options.
    (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.conf.navbars, (0, $4fcdf67dada2543a$export$2e2bcd8739ae039));
    let navs = this.opts.navbars;
    if (typeof navs == 'undefined') return;
    if (!(navs instanceof Array)) navs = [
        navs
    ];
    if (!navs.length) return;
    var navbars = {};
    navs.forEach((options)=>{
        options = (0, $256275208a499aa2$export$4f8b0ef91d76ca33)(options);
        if (!options.use) return;
        //	Create the navbar element.
        const navbar = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-navbar');
        //	Get the position for the navbar.
        let { position: position } = options;
        //	Restrict the position to either "bottom" or "top" (default).
        if (position !== 'bottom') position = 'top';
        //	Create the wrapper for the navbar position.
        if (!navbars[position]) navbars[position] = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-navbars.mm-navbars--' + position);
        navbars[position].append(navbar);
        //	Add content to the navbar.
        for(let c = 0, l = options.content.length; c < l; c++){
            const ctnt = options.content[c];
            //	The content is a string.
            if (typeof ctnt == 'string') {
                const func = $396c8988d79ce9e9$export$2e2bcd8739ae039.navbarContents[ctnt];
                //	The content refers to one of the navbar-presets ("prev", "title", etc).
                if (typeof func == 'function') //	Call the preset function.
                func.call(this, navbar);
                else {
                    //	Add the HTML.
                    //  Wrap the HTML in a single node
                    let node = $c9efe65a4853959a$export$185802fd694ee1f5('span');
                    node.innerHTML = ctnt;
                    //  If there was only a single node, use that.
                    const children = $c9efe65a4853959a$export$bacb5cc5a11aef16(node);
                    if (children.length == 1) node = children[0];
                    navbar.append(node);
                }
            //	The content is not a string, it must be an element.
            } else navbar.append(ctnt);
        }
        //	The type option is set.
        if (typeof options.type == 'string') {
            //	The function refers to one of the navbar-presets ("tabs").
            const func = $396c8988d79ce9e9$export$2e2bcd8739ae039.navbarTypes[options.type];
            if (typeof func == 'function') //	Call the preset function.
            func.call(this, navbar);
        }
        //	En-/disable the navbar.
        let enable = ()=>{
            navbar.classList.remove('mm-hidden');
        };
        let disable = ()=>{
            navbar.classList.add('mm-hidden');
        };
        if (typeof options.use == 'boolean') this.bind('initMenu:after', enable);
        else $539d76ccec06870f$export$e16d8520af44a096(options.use, enable, disable);
    });
    //	Add to menu.
    this.bind('initMenu:after', ()=>{
        for(let position in navbars)this.node.pnls[position == 'bottom' ? 'after' : 'before'](navbars[position]);
    });
}



const $a71fd1fb57107a9b$var$options = {
    scroll: false,
    update: false
};
var $a71fd1fb57107a9b$export$2e2bcd8739ae039 = $a71fd1fb57107a9b$var$options;


const $d2439a1c37b98371$var$configs = {
    scrollOffset: 0,
    updateOffset: 50
};
var $d2439a1c37b98371$export$2e2bcd8739ae039 = $d2439a1c37b98371$var$configs;




function $1c749001c00d495f$export$2e2bcd8739ae039() {
    this.opts.pageScroll = this.opts.pageScroll || {};
    this.conf.pageScroll = this.conf.pageScroll || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.pageScroll, (0, $a71fd1fb57107a9b$export$2e2bcd8739ae039));
    const configs = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.conf.pageScroll, (0, $d2439a1c37b98371$export$2e2bcd8739ae039));
    /** The currently "active" section */ var section;
    function scrollTo() {
        if (section) // section.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({
            top: section.getBoundingClientRect().top + document.scrollingElement.scrollTop - configs.scrollOffset,
            behavior: 'smooth'
        });
        section = null;
    }
    function anchorInPage(href) {
        try {
            if (href.slice(0, 1) == '#') return $c9efe65a4853959a$export$71aa6c912b956294((0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page, href)[0];
        } catch (err) {}
        return null;
    }
    if (this.opts.offCanvas.use && options.scroll) {
        //	Scroll to section after clicking menu item.
        this.bind('close:after', ()=>{
            scrollTo();
        });
        this.node.menu.addEventListener('click', (event)=>{
            var _a, _b;
            const href = ((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a[href]')) === null || _b === void 0 ? void 0 : _b.getAttribute('href')) || '';
            section = anchorInPage(href);
            if (section) {
                event.preventDefault();
                //	If the sidebar add-on is "expanded"...
                if (this.node.menu.matches('.mm-menu--sidebar-expanded') && this.node.wrpr.matches('.mm-wrapper--sidebar-expanded')) //	... scroll the page to the section.
                scrollTo();
                else //	... close the menu.
                this.close();
            }
        });
    }
    //	Update selected menu item after scrolling.
    if (options.update) {
        let scts = [];
        this.bind('initListview:after', (listview)=>{
            const listitems = $c9efe65a4853959a$export$bacb5cc5a11aef16(listview, '.mm-listitem');
            $c9efe65a4853959a$export$f6486d4f577dfcc4(listitems).forEach((anchor)=>{
                const section = anchorInPage(anchor.getAttribute('href'));
                if (section) scts.unshift(section);
            });
        });
        let _selected = -1;
        window.addEventListener('scroll', (evnt)=>{
            const scrollTop = window.scrollY;
            for(var s = 0; s < scts.length; s++)if (scts[s].offsetTop < scrollTop + configs.updateOffset) {
                if (_selected !== s) {
                    _selected = s;
                    let panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
                    let listitems = $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-listitem');
                    let anchors = $c9efe65a4853959a$export$f6486d4f577dfcc4(listitems);
                    anchors = anchors.filter((anchor)=>anchor.matches('[href="#' + scts[s].id + '"]'));
                    if (anchors.length) this.setSelected(anchors[0].parentElement);
                }
                break;
            }
        }, {
            passive: true
        });
    }
}


const $97d2e8583294f0da$var$options = {
    add: false,
    addTo: 'panels',
    noResults: 'No results found.',
    placeholder: 'Search',
    search: true,
    searchIn: 'panels',
    splash: '',
    title: 'Search'
};
var $97d2e8583294f0da$export$2e2bcd8739ae039 = $97d2e8583294f0da$var$options;


const $fd5467e515fefcc1$var$configs = {
    cancel: true,
    clear: true,
    form: {},
    input: {},
    panel: {},
    submit: false
};
var $fd5467e515fefcc1$export$2e2bcd8739ae039 = $fd5467e515fefcc1$var$configs;



var $1a5640fa5241f3c5$export$2e2bcd8739ae039 = {
    'cancel': 'abbrechen',
    'Cancel searching': 'Suche abbrechen',
    'Clear searchfield': "Suchfeld l\xf6schen",
    'No results found.': 'Keine Ergebnisse gefunden.',
    'Search': 'Suche'
};


var $9959d3c74d8a0eda$export$2e2bcd8739ae039 = {
    'cancel': "\u0627\u0646\u0635\u0631\u0627\u0641",
    'Cancel searching': "\u0644\u063A\u0648 \u062C\u0633\u062A\u062C\u0648",
    'Clear searchfield': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u0641\u06CC\u0644\u062F \u062C\u0633\u062A\u062C\u0648",
    'No results found.': "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
    'Search': "\u062C\u0633\u062A\u062C\u0648"
};


var $8adb705325032488$export$2e2bcd8739ae039 = {
    'cancel': 'annuleren',
    'Cancel searching': 'Zoeken annuleren',
    'Clear searchfield': 'Zoekveld leeg maken',
    'No results found.': 'Geen resultaten gevonden.',
    'Search': 'Zoeken'
};


var $aa379fe035ce4c22$export$2e2bcd8739ae039 = {
    'cancel': 'cancelar',
    'Cancel searching': 'Cancelar pesquisa',
    'Clear searchfield': 'Limpar campo de pesquisa',
    'No results found.': 'Nenhum resultado encontrado.',
    'Search': 'Buscar'
};


var $f0e075dc12619695$export$2e2bcd8739ae039 = {
    'cancel': "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
    'Cancel searching': "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A",
    'Clear searchfield': "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435 \u043F\u043E\u0438\u0441\u043A\u0430",
    'No results found.': "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    'Search': "\u041D\u0430\u0439\u0442\u0438"
};


var $f248b6927535e5f4$export$2e2bcd8739ae039 = {
    'cancel': "zru\u0161i\u0165",
    'Cancel searching': "Zru\u0161i\u0165 vyh\u013Ead\xe1vanie",
    'Clear searchfield': "Vymaza\u0165 pole vyh\u013Ead\xe1vania",
    'No results found.': "Neboli n\xe1jden\xe9 \u017Eiadne v\xfdsledky.",
    'Search': "Vyh\u013Ead\xe1vanie"
};


var $e97e42b531002d79$export$2e2bcd8739ae039 = {
    'cancel': "\u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'Cancel searching': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A",
    'Clear searchfield': "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u043B\u0435 \u043F\u043E\u0448\u0443\u043A\u0443",
    'No results found.': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    'Search': "\u041F\u043E\u0448\u0443\u043A"
};


function $66e3951ad88016ea$export$2e2bcd8739ae039() {
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $1a5640fa5241f3c5$export$2e2bcd8739ae039), 'de');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $9959d3c74d8a0eda$export$2e2bcd8739ae039), 'fa');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $8adb705325032488$export$2e2bcd8739ae039), 'nl');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $aa379fe035ce4c22$export$2e2bcd8739ae039), 'pt_br');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $f0e075dc12619695$export$2e2bcd8739ae039), 'ru');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $f248b6927535e5f4$export$2e2bcd8739ae039), 'sk');
    (0, $17526d088c38b2ee$export$e16d8520af44a096)((0, $e97e42b531002d79$export$2e2bcd8739ae039), 'uk');
}




//  Add the translations.
(0, $66e3951ad88016ea$export$2e2bcd8739ae039)();
function $d7e14363b04f0d17$export$2e2bcd8739ae039() {
    this.opts.searchfield = this.opts.searchfield || {};
    this.conf.searchfield = this.conf.searchfield || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.searchfield, (0, $97d2e8583294f0da$export$2e2bcd8739ae039));
    const configs = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.conf.searchfield, (0, $fd5467e515fefcc1$export$2e2bcd8739ae039));
    if (!options.add) return;
    switch(options.addTo){
        case 'panels':
            options.addTo = '.mm-panel';
            break;
        case 'searchpanel':
            options.addTo = '.mm-panel--search';
            break;
    }
    switch(options.searchIn){
        case 'panels':
            options.searchIn = '.mm-panel';
            break;
    }
    //  Add a searchfield to panels matching the "addTo" querySelector.
    this.bind('initPanel:after', (panel)=>{
        if (panel.matches(options.addTo) && !panel.closest('.mm-listitem--vertical')) $d7e14363b04f0d17$var$initPanel.call(this, panel);
    });
    this.bind('initMenu:after', ()=>{
        //  Create the resultspanel.
        const resultspanel = $d7e14363b04f0d17$var$createResultsPanel.call(this);
        $d7e14363b04f0d17$var$initPanel.call(this, resultspanel);
        //  Add a searchfield to anything other than a panel (most likely a navbar).
        $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, options.addTo).forEach((wrapper)=>{
            if (!wrapper.matches('.mm-panel')) {
                /** The searchform. */ const form = $d7e14363b04f0d17$var$createSearchfield.call(this, true);
                //  Add the form to the panel.
                wrapper.append(form);
                /** The input node. */ const input = $c9efe65a4853959a$export$71aa6c912b956294(form, 'input')[0];
                //  Bind events for opening and closing the resultspanel.
                // With a splash...
                if (options.splash.length) {
                    //  Open on focus.
                    input.addEventListener('focusin', ()=>{
                        this.openPanel(resultspanel, false, false);
                    });
                    //  Show cancel button if searchpanel is opened.
                    this.bind('openPanel:after', (panel)=>{
                        if (panel.matches('.mm-panel--search')) form.classList.add('mm-searchfield--cancelable');
                        else form.classList.remove('mm-searchfield--cancelable');
                    });
                // ...without splash.
                } else {
                    //  Open resultspanel when searching.
                    this.bind('search:after', ()=>{
                        this.openPanel(resultspanel, false, false);
                    });
                    //  Close resultspanel when resetting.
                    input.addEventListener('focusout', ()=>{
                        if (!input.value.length) this.closePanel(resultspanel, false);
                    });
                }
                //  Initialize searching.
                $d7e14363b04f0d17$var$initSearch.call(this, form);
            }
        });
    });
    //	Blur searchfield
    this.bind('close:before', ()=>{
        $c9efe65a4853959a$export$71aa6c912b956294(this.node.menu, '.mm-searchfield input').forEach((input)=>{
            input.blur();
        });
    });
}
/**
 * Create the searchpanel.
 * @param {Mmenu} this
 */ const $d7e14363b04f0d17$var$createResultsPanel = function() {
    /** Options for the searchfield. */ const options = this.opts.searchfield;
    /** Configs for the searchfield. */ const configs = this.conf.searchfield;
    /** The panel. */ let panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--search')[0];
    //	Only once
    if (panel) return panel;
    panel = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-panel--search');
    //	Add attributes to the panel.    
    $d7e14363b04f0d17$var$_addAttributes(panel, configs.panel);
    //  Add a title to the panel.
    if (options.title.length) panel.dataset.mmTitle = this.i18n(options.title);
    //  Add a listview to the panel.
    panel.append($c9efe65a4853959a$export$185802fd694ee1f5('ul'));
    this._initPanel(panel);
    return panel;
};
/**
 * Add a searchfield, splash message and no-results message to a panel.
 * @param {Mmenu}       this
 * @param {HTMLElement} panel The panel to initialise.
 */ const $d7e14363b04f0d17$var$initPanel = function(panel) {
    /** Options for the searchfield. */ const options = this.opts.searchfield;
    //	Create the searchfield.
    if (panel.matches(options.addTo)) {
        /** Whether or not the panel is the resultspanel */ const isResultspanel = panel.matches('.mm-panel--search');
        //  Only one per panel.
        if (!$c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-searchfield').length) {
            /** The searchform. */ const form = $d7e14363b04f0d17$var$createSearchfield.call(this, isResultspanel);
            if (isResultspanel) form.classList.add('mm-searchfield--cancelable');
            //  Add the form to the panel.
            panel.prepend(form);
            //  Initialize searching.
            $d7e14363b04f0d17$var$initSearch.call(this, form);
        }
    }
    //	Create the splash content.
    if (options.splash.length && panel.matches('.mm-panel--search')) //  Only one per panel.
    {
        if (!$c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-panel__splash').length) {
            /** The splash content node. */ const splash = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-panel__splash');
            splash.innerHTML = options.splash;
            panel.append(splash);
        }
    }
    //  Add no results message.
    if (options.noResults.length) //	Only once per panel.
    {
        if (!$c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-panel__noresults').length) {
            /** The no results message node. */ const message = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-panel__noresults');
            message.innerHTML = this.i18n(options.noResults);
            panel.append(message);
        }
    }
};
/**
 * Create the searchfield.
 * @param {Mmenu}   this
 * @param {boolean} [addCancel=false] Whether or not to add the cancel button
 */ const $d7e14363b04f0d17$var$createSearchfield = function(addCancel = false) {
    /** Options for the searchfield. */ const options = this.opts.searchfield;
    /** Configs for the searchfield. */ const configs = this.conf.searchfield;
    /** The form node. */ const form = $c9efe65a4853959a$export$185802fd694ee1f5('form.mm-searchfield');
    //	Add attributes to the form
    $d7e14363b04f0d17$var$_addAttributes(form, configs.form);
    /** The fieldset node. */ const field = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-searchfield__input');
    form.append(field);
    /** The input node. */ const input = $c9efe65a4853959a$export$185802fd694ee1f5('input');
    field.append(input);
    //	Add attributes to the input
    input.type = 'text';
    input.autocomplete = 'off';
    input.placeholder = this.i18n(options.placeholder);
    input.setAttribute('aria-label', this.i18n(options.placeholder));
    $d7e14363b04f0d17$var$_addAttributes(input, configs.input);
    //	Add a button to submit to the form.
    if (configs.submit) {
        /** The submit button. */ const submit = $c9efe65a4853959a$export$185802fd694ee1f5('button.mm-btnreset.mm-btn.mm-btn--next.mm-searchfield__btn');
        submit.type = 'submit';
        field.append(submit);
    } else if (configs.clear) {
        /** The reset button. */ const reset = $c9efe65a4853959a$export$185802fd694ee1f5('button.mm-btnreset.mm-btn.mm-btn--close.mm-searchfield__btn');
        reset.type = 'reset';
        reset.setAttribute('aria-label', this.i18n('Clear searchfield'));
        field.append(reset);
        //  Apparently, resetting a form doesn't trigger any event on the input,
        //  so we manually dispatch the event, one frame later :/
        form.addEventListener('reset', ()=>{
            window.requestAnimationFrame(()=>{
                input.dispatchEvent(new Event('input'));
            });
        });
    }
    // Add a button to close the searchpanel.
    if (configs.cancel && addCancel) {
        /** The cancel button. */ const cancel = $c9efe65a4853959a$export$185802fd694ee1f5('a.mm-searchfield__cancel');
        cancel.href = '#';
        cancel.setAttribute('aria-label', this.i18n('Cancel searching'));
        cancel.textContent = this.i18n('cancel');
        form.append(cancel);
        // Close the search panel.
        cancel.addEventListener('click', (event)=>{
            event.preventDefault();
            this.closePanel($c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--search')[0], false);
        });
    }
    return form;
};
/**
 * Initialize the searching.
 * @param {Mmenu}       this
 * @param {HTMLElement} form The searchform.
 */ const $d7e14363b04f0d17$var$initSearch = function(form) {
    /** Options for the searchfield. */ const options = this.opts.searchfield;
    /** The panel the results will be in. */ const resultspanel = form.closest('.mm-panel') || $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, '.mm-panel--search')[0];
    /** The input node. */ const input = $c9efe65a4853959a$export$71aa6c912b956294(form, 'input')[0];
    /** Where to search. */ let searchIn = resultspanel.matches('.mm-panel--search') ? $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, options.searchIn) : [
        resultspanel
    ];
    //  Filter out the resultspanel
    searchIn = searchIn.filter((panel)=>!panel.matches('.mm-panel--search'));
    /** Search */ const search = ()=>{
        /** The searchquery */ const query = input.value.toLowerCase().trim();
        if (query.length) form.classList.add('mm-searchfield--searching');
        else form.classList.remove('mm-searchfield--searching');
        if (!options.search) return;
        /** All listitems */ const listitems = [];
        searchIn.forEach((panel)=>{
            //  Scroll all panels to top.
            panel.scrollTop = 0;
            //  Find listitems.
            listitems.push(...$c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-listitem'));
        });
        //	Search
        if (query.length) {
            // Trigger event.
            this.trigger('search:before');
            resultspanel.classList.add('mm-panel--searching');
            //	Add data attribute to the matching listitems.
            listitems.forEach((listitem)=>{
                const text = $c9efe65a4853959a$export$bacb5cc5a11aef16(listitem, '.mm-listitem__text')[0];
                if (!text || $c9efe65a4853959a$export$6f093cfa640b7166(text).toLowerCase().indexOf(query) > -1) listitem.dataset.mmSearchresult = query;
            });
            /** The number of matching results. */ let count = 0;
            //  Resultspanel: Copy results to resultspanel.
            if (resultspanel.matches('.mm-panel--search')) count = $d7e14363b04f0d17$var$_searchResultsPanel(resultspanel, query, searchIn);
            else count = $d7e14363b04f0d17$var$_searchPerPanel(query, searchIn);
            resultspanel.classList[count == 0 ? 'add' : 'remove']('mm-panel--noresults');
            // Trigger event.
            this.trigger('search:after');
        //  Don't search, reset all.
        } else {
            // Trigger event.
            this.trigger('clear:before');
            resultspanel.classList.remove('mm-panel--searching', 'mm-panel--noresults');
            //  Resultspanel.
            if (resultspanel.matches('.mm-panel--search')) {
                $d7e14363b04f0d17$var$_resetResultsPanel(resultspanel);
                if (!options.splash) this.closePanel(resultspanel, false, false);
            //  Search per panel: Show all listitems and dividers.
            } else $d7e14363b04f0d17$var$_resetPerPanel(searchIn);
            // Trigger event.
            this.trigger('clear:after');
        }
    };
    input.addEventListener('input', search);
    search();
};
const $d7e14363b04f0d17$var$_searchResultsPanel = (resultspanel, query, searchIn)=>{
    /** The listview for the results/ */ const listview = $c9efe65a4853959a$export$71aa6c912b956294(resultspanel, '.mm-listview')[0];
    //  Clear listview.
    listview.innerHTML = '';
    /** Amount of resutls found. */ let count = 0;
    searchIn.forEach((panel)=>{
        /** The results in this panel. */ const results = $c9efe65a4853959a$export$71aa6c912b956294(panel, `[data-mm-searchresult="${query}"]`);
        count += results.length;
        if (results.length) {
            /** Title for the panel. */ const title = $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-navbar__title')[0];
            //  Add a divider to indicate in what panel the results are.
            if (title) {
                const divider = $c9efe65a4853959a$export$185802fd694ee1f5('li.mm-divider');
                divider.innerHTML = title.innerHTML;
                listview.append(divider);
            }
            //  Add the results
            results.forEach((result)=>{
                const clone = result.cloneNode(true);
                listview.append(clone);
            });
        }
    });
    //  Remove inline subpanels.
    $c9efe65a4853959a$export$71aa6c912b956294(listview, '.mm-panel').forEach((panel)=>{
        panel.remove();
    });
    //  Remove ID's and data-attributes
    [
        'id',
        'data-mm-parent',
        'data-mm-child'
    ].forEach((attr)=>{
        $c9efe65a4853959a$export$71aa6c912b956294(listview, `[${attr}]`).forEach((elem)=>{
            elem.removeAttribute(attr);
        });
    });
    //  Remove "opened" class
    $c9efe65a4853959a$export$71aa6c912b956294(listview, '.mm-listitem--opened').forEach((listitem)=>{
        listitem.classList.remove('mm-listitem--opened');
    });
    return count;
};
const $d7e14363b04f0d17$var$_resetResultsPanel = (resultspanel)=>{
    /** The listview for the results. */ const listview = $c9efe65a4853959a$export$71aa6c912b956294(resultspanel, '.mm-listview')[0];
    //  Clear listview.
    listview.innerHTML = '';
};
const $d7e14363b04f0d17$var$_searchPerPanel = (query, searchIn)=>{
    /** Amount of resutls found. */ let count = 0;
    searchIn.forEach((panel)=>{
        /** The results in this panel. */ const results = $c9efe65a4853959a$export$71aa6c912b956294(panel, `[data-mm-searchresult="${query}"]`);
        count += results.length;
        if (results.length) //  Add first preceeding divider to the results.
        results.forEach((result)=>{
            const divider = $c9efe65a4853959a$export$5a01ccd45552d0b4(result, '.mm-divider')[0];
            if (divider) divider.dataset.mmSearchresult = query;
        });
        $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-listitem, .mm-divider').forEach((item)=>{
            //  Hide all
            item.classList.add('mm-hidden');
            //  Show matching + its parents.
            if (item.dataset.mmSearchresult === query) [
                item,
                ...$c9efe65a4853959a$export$7901f6cd558b9a93(item, '.mm-listitem')
            ].forEach((item2)=>{
                item2.classList.remove('mm-hidden');
            });
        });
    });
    return count;
};
const $d7e14363b04f0d17$var$_resetPerPanel = (searchIn)=>{
    searchIn.forEach((panel)=>{
        $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-listitem, .mm-divider').forEach((item)=>{
            item.classList.remove('mm-hidden');
        });
    });
};
/**
 * Add array of attributes to an element.
 * @param {HTMLEement}  element     The element to add the attributes to.
 * @param {Object}      attributes  The attributes to add.
 */ const $d7e14363b04f0d17$var$_addAttributes = (element, attributes)=>{
    if (attributes) Object.keys(attributes).forEach((a)=>{
        element[a] = attributes[a];
    });
};


const $7078fecb6e6720f5$var$options = {
    add: false,
    addTo: 'panels'
};
var $7078fecb6e6720f5$export$2e2bcd8739ae039 = $7078fecb6e6720f5$var$options;





function $b13a58897846432c$export$2e2bcd8739ae039() {
    this.opts.sectionIndexer = this.opts.sectionIndexer || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.sectionIndexer, (0, $7078fecb6e6720f5$export$2e2bcd8739ae039));
    if (!options.add) return;
    this.bind('initPanels:after', ()=>{
        //	Add the indexer, only if it does not allready excists
        if (!this.node.indx) {
            let buttons = '';
            'abcdefghijklmnopqrstuvwxyz'.split('').forEach((letter)=>{
                buttons += '<a href="#">' + letter + '</a>';
            });
            let indexer = $c9efe65a4853959a$export$185802fd694ee1f5('div.mm-sectionindexer');
            indexer.innerHTML = buttons;
            this.node.pnls.prepend(indexer);
            this.node.indx = indexer;
            //	Prevent default behavior when clicking an anchor
            this.node.indx.addEventListener('click', (evnt)=>{
                const anchor = evnt.target;
                if (anchor.matches('a')) evnt.preventDefault();
            });
            //	Scroll onMouseOver / onTouchStart
            let mouseOverEvent = (evnt)=>{
                if (!evnt.target.matches('a')) return;
                const letter = evnt.target.textContent;
                const panel = $c9efe65a4853959a$export$bacb5cc5a11aef16(this.node.pnls, '.mm-panel--opened')[0];
                let newTop = -1, oldTop = panel.scrollTop;
                panel.scrollTop = 0;
                $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-divider').filter((divider)=>!divider.matches('.mm-hidden')).forEach((divider)=>{
                    if (newTop < 0 && letter == divider.textContent.trim().slice(0, 1).toLowerCase()) newTop = divider.offsetTop;
                });
                panel.scrollTop = newTop > -1 ? newTop : oldTop;
            };
            if ($e4362909c85b6c54$export$d0b7ea69ab6056df) {
                this.node.indx.addEventListener('touchstart', mouseOverEvent);
                this.node.indx.addEventListener('touchmove', mouseOverEvent);
            } else this.node.indx.addEventListener('mouseover', mouseOverEvent);
        }
        //	Show or hide the indexer
        this.bind('openPanel:before', (panel)=>{
            const active = $c9efe65a4853959a$export$71aa6c912b956294(panel, '.mm-divider').filter((divider)=>!divider.matches('.mm-hidden')).length;
            this.node.indx.classList[active ? 'add' : 'remove']('mm-sectionindexer--active');
        });
    });
}


const $14bbdb447c03fd09$var$options = {
    current: true,
    hover: false,
    parent: false
};
var $14bbdb447c03fd09$export$2e2bcd8739ae039 = $14bbdb447c03fd09$var$options;




function $708ce5a15ca9f91e$export$2e2bcd8739ae039() {
    this.opts.setSelected = this.opts.setSelected || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.setSelected, (0, $14bbdb447c03fd09$export$2e2bcd8739ae039));
    //	Find current by URL
    if (options.current == 'detect') {
        const findCurrent = (url)=>{
            url = url.split('?')[0].split('#')[0];
            const anchor = this.node.menu.querySelector('a[href="' + url + '"], a[href="' + url + '/"]');
            if (anchor) this.setSelected(anchor.parentElement);
            else {
                const arr = url.split('/').slice(0, -1);
                if (arr.length) findCurrent(arr.join('/'));
            }
        };
        this.bind('initMenu:after', ()=>{
            findCurrent.call(this, window.location.href);
        });
    //	Remove current selected item
    } else if (!options.current) this.bind('initListview:after', (listview)=>{
        $c9efe65a4853959a$export$bacb5cc5a11aef16(listview, '.mm-listitem--selected').forEach((listitem)=>{
            listitem.classList.remove('mm-listitem--selected');
        });
    });
    //	Add :hover effect on items
    if (options.hover) this.bind('initMenu:after', ()=>{
        this.node.menu.classList.add('mm-menu--selected-hover');
    });
    //	Set parent item selected for submenus
    if (options.parent) {
        this.bind('openPanel:after', (panel)=>{
            //	Remove all
            $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, '.mm-listitem--selected-parent').forEach((listitem)=>{
                listitem.classList.remove('mm-listitem--selected-parent');
            });
            //	Move up the DOM tree
            let current = panel;
            while(current){
                let li = $c9efe65a4853959a$export$71aa6c912b956294(this.node.pnls, `#${current.dataset.mmParent}`)[0];
                current = li === null || li === void 0 ? void 0 : li.closest('.mm-panel');
                if (li && !li.matches('.mm-listitem--vertical')) li.classList.add('mm-listitem--selected-parent');
            }
        });
        this.bind('initMenu:after', ()=>{
            this.node.menu.classList.add('mm-menu--selected-parent');
        });
    }
}



const $c47e7b746e18d3c6$var$options = {
    collapsed: {
        use: false
    },
    expanded: {
        use: false,
        initial: 'open'
    }
};
var $c47e7b746e18d3c6$export$2e2bcd8739ae039 = $c47e7b746e18d3c6$var$options;




function $1e132fa2ac79a29e$export$2e2bcd8739ae039() {
    // Only for off-canvas menus.
    if (!this.opts.offCanvas.use) return;
    this.opts.sidebar = this.opts.sidebar || {};
    //	Extend options.
    const options = (0, $9873b750a4e3050d$export$8b58be045bf06082)(this.opts.sidebar, (0, $c47e7b746e18d3c6$export$2e2bcd8739ae039));
    //	Collapsed
    if (options.collapsed.use) {
        //	Make the menu collapsable.
        this.bind('initMenu:after', ()=>{
            this.node.menu.classList.add('mm-menu--sidebar-collapsed');
        });
        /** Enable the collapsed sidebar */ let enable = ()=>{
            this.node.wrpr.classList.add('mm-wrapper--sidebar-collapsed');
        };
        /** Disable the collapsed sidebar */ let disable = ()=>{
            this.node.wrpr.classList.remove('mm-wrapper--sidebar-collapsed');
        };
        if (typeof options.collapsed.use === 'boolean') this.bind('initMenu:after', enable);
        else $539d76ccec06870f$export$e16d8520af44a096(options.collapsed.use, enable, disable);
    }
    //	Expanded
    if (options.expanded.use) {
        //	Make the menu expandable
        this.bind('initMenu:after', ()=>{
            this.node.menu.classList.add('mm-menu--sidebar-expanded');
        });
        let expandedEnabled = false;
        /** Enable the expanded sidebar */ let enable = ()=>{
            expandedEnabled = true;
            this.node.wrpr.classList.add('mm-wrapper--sidebar-expanded');
            this.node.menu.removeAttribute('aria-modal');
            this.open();
            (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
        };
        /** Disable the expanded sidebar */ let disable = ()=>{
            expandedEnabled = false;
            this.node.wrpr.classList.remove('mm-wrapper--sidebar-expanded');
            this.node.menu.setAttribute('aria-modal', 'true');
            this.close();
        };
        if (typeof options.expanded.use == 'boolean') this.bind('initMenu:after', enable);
        else $539d76ccec06870f$export$e16d8520af44a096(options.expanded.use, enable, disable);
        //  Store exanded state when opening and closing the menu.
        this.bind('close:after', ()=>{
            if (expandedEnabled) window.sessionStorage.setItem('mmenuExpandedState', 'closed');
        });
        this.bind('open:after', ()=>{
            if (expandedEnabled) {
                window.sessionStorage.setItem('mmenuExpandedState', 'open');
                (0, $52a95b04b2a63e73$export$2e2bcd8739ae039).node.page.removeAttribute('inert');
            }
        });
        //  Set the initial state
        let initialState = options.expanded.initial;
        const state = window.sessionStorage.getItem('mmenuExpandedState');
        switch(state){
            case 'open':
            case 'closed':
                initialState = state;
                break;
        }
        if (initialState === 'closed') this.bind('init:after', ()=>{
            this.close();
        });
    }
}


(0, $52a95b04b2a63e73$export$2e2bcd8739ae039).addons = {
    offcanvas: //	Core add-ons
    $add3d3efdc58e6a9$export$2e2bcd8739ae039,
    scrollBugFix: $9980f7c0a55fda66$export$2e2bcd8739ae039,
    theme: $b1dfd79d2c8ad54f$export$2e2bcd8739ae039,
    backButton: //	Add-ons
    $8453c4a8b7caaa18$export$2e2bcd8739ae039,
    counters: $e7deeb5738786d8d$export$2e2bcd8739ae039,
    iconbar: $bc26f8a78d30aced$export$2e2bcd8739ae039,
    iconPanels: $e91f5665a6f095f0$export$2e2bcd8739ae039,
    navbars: $396c8988d79ce9e9$export$2e2bcd8739ae039,
    pageScroll: $1c749001c00d495f$export$2e2bcd8739ae039,
    searchfield: $d7e14363b04f0d17$export$2e2bcd8739ae039,
    sectionIndexer: $b13a58897846432c$export$2e2bcd8739ae039,
    setSelected: $708ce5a15ca9f91e$export$2e2bcd8739ae039,
    sidebar: $1e132fa2ac79a29e$export$2e2bcd8739ae039
};
var //  Export module
$81be6cc54300ddb2$export$2e2bcd8739ae039 = (0, $52a95b04b2a63e73$export$2e2bcd8739ae039);
//	Global namespace
if (window) window.Mmenu = (0, $52a95b04b2a63e73$export$2e2bcd8739ae039);


function $89fc0fa524ebb234$var$faqDropdown() {
    const dropdowns = document.querySelectorAll(".dropdown-toggle");
    for(let i = 0; i < dropdowns.length; i++){
        const dropdown = dropdowns[i];
        const plusIcon = dropdown.querySelector('img[src*="icon-circled-plus"]');
        const minusIcon = dropdown.querySelector('img[src*="icon-circled-minus"]');
        const content = dropdown.nextElementSibling;
        dropdown.addEventListener("click", function() {
            if (content.classList.contains("open")) {
                minusIcon.style.transform = "rotate(-45deg)";
                setTimeout(function() {
                    plusIcon.style.display = "block";
                    minusIcon.style.display = "none";
                    plusIcon.style.transform = "rotate(0deg)";
                }, 300);
            } else {
                plusIcon.style.transform = "rotate(45deg)";
                setTimeout(function() {
                    minusIcon.style.display = "block";
                    plusIcon.style.display = "none";
                    minusIcon.style.transform = "rotate(0deg)";
                }, 300);
            }
            content.classList.toggle("open");
        });
    }
}
$89fc0fa524ebb234$var$faqDropdown();


document.addEventListener("DOMContentLoaded", ()=>{
    var menu = new Mmenu("#mobile-menu", {
        "extensions": [
            "position-right"
        ],
        "hooks": {
            "open:before": ()=>{
                jQuery(".hamburger").addClass('is-active');
            },
            "close:before": ()=>{
                jQuery(".hamburger").removeClass('is-active');
            }
        },
        offCanvas: {
            position: "right",
            page: {
                selector: "#page_wrapper"
            }
        }
    });
    jQuery('.mm-navbar__title').attr('href', '#');
    jQuery('.mm-wrapper__blocker').on('click', ()=>{
        menu.API.close();
    });
});


//Agent dashboard grab video thumbnail
var $2860c69c4d77c25d$var$elem = jQuery('.acf-file-uploader.has-value');
$2860c69c4d77c25d$var$elem.each(function() {
    var src = jQuery(this).find("a[data-name=filename]").attr('href');
    jQuery(this).append('<video src="' + src + '"></video>');
});
//create listener event for class change
jQuery(function() {
    (function(jQuery1) {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        jQuery1.fn.attrchange = function(callback) {
            if (MutationObserver) {
                var options = {
                    subtree: false,
                    attributes: true
                };
                var observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(e) {
                        callback.call(e.target, e.attributeName);
                    });
                });
                return this.each(function() {
                    observer.observe(this, options);
                });
            }
        };
    })(jQuery);
    //Now you need to append event listener
    jQuery('.acf-file-uploader').attrchange(function(attrName) {
        if (attrName == 'class') {
            if (jQuery(this).hasClass('has-value')) {
                var src = jQuery(this).find("a[data-name=filename]").attr('href');
                jQuery(this).append('<video src="' + src + '"></video>');
            } else jQuery(this).find('video').remove();
        }
    });
});

})();
//# sourceMappingURL=index.js.map
